// extracted by mini-css-extract-plugin
module.exports = {"radio":"question_radio__BarM8","radioButton":"question_radioButton__YUxz_"};